<template>
  <div>
    <PageAllow controller="StockTrucks" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="SearcherKeyword = $event"
                :label="$t('StockTrucks.Keyword')"
              />
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 配送线路-->
              <v-btn
                small
                color="primary"
                @click.stop="currentItemMode = 'new'"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("DistributionUsers.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="StockTrucks"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 查看相关 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    >fa-external-link-alt
                  </v-icon>
                </template>
                <span>{{ $t("StockTrucks.externalLinkToStockTrucks") }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("StockTrucks.ObjectName")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip top v-if="item.delete_flg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("StockTrucks.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('StockTrucks.ObjectName')"
      @confirm="
        deleteStockTrucks();
        deleteDialog = false;
      "
    />
    <!-- 操作跳转 -->
    <StockTrucksDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getStockTrucksFromAPI()"
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import StockTrucksDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import StockTrucks from "@/api/stock_trucks";

const defaultOptions = {
  SearcherKeyword: "",
};

export default {
  name: "stocksContainer",
  data: () => ({
    StockTrucks: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stockTrucks-options")
        ? sessionStorage.getItem("stockTrucks-options")
        : JSON.stringify(defaultOptions)
    ),
    SearcherKeyword: "",
    currentItemMode: null,
    currentItem: null,
    deleteDialog: false,
  }),
  components: {
    DialogDelete,
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    StockTrucksDetail,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("StockTrucks.title"),
        disabled: true,
      },
    ],
    headers: () => [
      {
        text: i18n.t("StockTrucks.Fields.truck_name"),
        align: "start",
        sortable: false,
        value: "truck_name",
      },
      {
        text: i18n.t("StockTrucks.Fields.truck_code"),
        align: "start",
        sortable: false,
        value: "truck_code",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading"]),
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.SearcherKeyword,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getStockTrucksFromAPI() {
      StockTrucks.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.StockTrucks = response.data.stock_trucks;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    deleteStockTrucks() {
      // 删除
      if (this.currentItem) {
        StockTrucks.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getStockTrucksFromAPI(); // 删除成功重新刷新
            }
          }.bind(this)
        );
      }
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockTrucksFromAPI();
        sessionStorage.setItem(
          "stockTrucks-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
  },
};
</script>

<style>
</style>